import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import { toCoverageUpsertCommand } from '@unify/fhir-model/schemas';
import { config } from '../../../config';
import type { ClientPortalInsurancePriority } from '../utils/clientPortalFhirTypes';

export const CLIENT_PORTAL_COVERAGE_UPDATE_BOT_IDENTIFIER = {
  system: 'https://unify.health/bots',
  value: 'client-portal-coverage-update',
} as const;

function getClientPortalCoverageUpdateBotTarget(): string | { system: string; value: string } {
  const id = import.meta.env.VITE_MEDPLUM_CLIENT_PORTAL_COVERAGE_UPDATE_BOT_ID?.trim();
  if (id) return id;
  const system =
    import.meta.env.VITE_MEDPLUM_CLIENT_PORTAL_COVERAGE_UPDATE_BOT_IDENTIFIER_SYSTEM?.trim()
    ?? CLIENT_PORTAL_COVERAGE_UPDATE_BOT_IDENTIFIER.system;
  const value =
    import.meta.env.VITE_MEDPLUM_CLIENT_PORTAL_COVERAGE_UPDATE_BOT_IDENTIFIER_VALUE?.trim()
    ?? CLIENT_PORTAL_COVERAGE_UPDATE_BOT_IDENTIFIER.value;
  return { system, value };
}

export interface SaveClientPortalCoverageInput {
  patientId: string;
  coverageId?: string;
  priority: ClientPortalInsurancePriority;
  payerOrgId: string;
  payerName?: string;
  memberId: string;
  groupNumber?: string;
  planName?: string;
  relationship?: string;
  subscriberFirstName?: string;
  subscriberLastName?: string;
  subscriberDateOfBirth?: string;
  periodStart?: string;
  periodEnd?: string;
}

export interface SaveClientPortalCoverageResult {
  coverageId: string;
  priority: ClientPortalInsurancePriority;
}

export async function saveClientPortalCoverageViaBot(
  medplum: MedplumClient,
  input: SaveClientPortalCoverageInput,
): Promise<SaveClientPortalCoverageResult> {
  if (!config.medplum.clientId) {
    throw new Error('Medplum client is not configured.');
  }
  const command = toCoverageUpsertCommand(input);
  return medplum.executeBot(
    getClientPortalCoverageUpdateBotTarget(),
    command,
    ContentType.JSON,
  ) as Promise<SaveClientPortalCoverageResult>;
}
